<app-public-header></app-public-header>
<div class="w-full min-h-screen-safe flex flex-col items-center justify-center bg-westetics-purple-800">
  <div class="lg:w-1/2 w-11/12 border rounded-2xl border-gray-300 shadow-xl lg:py-16 py-12 px-6 bg-white 
              flex flex-col gap-6 items-center justify-center text-center">
    
    <fa-icon [icon]="faCircleCheck" class="text-green-500 text-7xl md:text-8xl"></fa-icon>
    
    <h1 class="text-3xl md:text-4xl font-bold text-gray-800">Tudo pronto!</h1>
    
    <div class="text-center">
      <p class="text-lg md:text-xl text-gray-600 max-w-md">
        Obrigado por ter preenchido sua ficha!
      </p>
      <p class="text-base md:text-lg text-gray-500 max-w-md mt-2">
        Por favor, avise um de nossos atendentes.
      </p>
    </div>
    
    <p class="mt-6 text-sm md:text-base text-gray-500">
      Você já pode fechar essa tela.
    </p>
  </div>
</div>
